import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { UserData } from '../model/user-data';
import { UsersDataResponse } from '../model/users-data-response';

@Component({
    selector: 'app-store-management',
    templateUrl: './store-management.component.html',
    styleUrls: ['./store-management.component.scss'],
    standalone: false
})
export class StoreManagementComponent implements OnInit {
  user: UsersDataResponse;
  userData: UserData;
  navLinks: any[];
  activeLinkIndex = -1;
  activeLink: any;
  background = '';
  userAction= '';
  storeList = [

    {
      label: 'Users List',
      path: './store-users',
      index: 0
    },
    {
      label: 'Store Maintenance',
      path: './store-maintainence',
      index: 1
    }
      
  ];
  storeUserList = [

    {
      label: 'Users List',
      path: './add-edit-store-user',
      index: 0
    },
    {
      label: 'Store Maintenance',
      path: './store-maintainence',
      index: 1
    }
    
  
  ];
  storeEditList = [

    {
      label: 'Users List',
      path: './store-users',
      index: 0
    },
    {
      label: 'Store Maintenance',
      path: './edit-store',
      index: 1
    }
    
  
  ];

 

  constructor(private route: ActivatedRoute,
    private router: Router, private userservice: UserService) {
      this.route.queryParams
      .subscribe(params => {
       this.userAction = params['action'];
    this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
      if(this.userAction===undefined){
        this.navLinks=this.storeList;
        }else
      if(this.userAction==='store-user-edit'|| this.userAction==='store-user-add'){
      this.navLinks=this.storeUserList;
      }else
      if(this.userAction==='store-edit'){
        this.navLinks=this.storeEditList;
      }


    })

  })


  }
  ngOnInit(): void {
    this.router.events.subscribe((res) => {
      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.path === '.' + this.router.url));
    });


  }


}